import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import {
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
} from '@mui/lab';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import BusinessTaxSubMenu from '@/components/nav/BusinessTaxSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';

// import Form1065 from '../resources/tax-extension/form-7004-for-form-1065';

const Form565 = () => {
  const [open, setOpen] = useState(false);
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Don't miss your payroll tax return deadline.`,
  //   SubHeading:
  //     'E-file Form 940 for easy compliance. File now and save time and stress.',
  //   CtaText: 'E-file Form 940 Now',
  //   CtaSubHeading: `Stay tax compliant with the IRS`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };
  // const [scrollIndex, setScrollIndex] = useState(0);
  // const [closeSticky, setCloseSticky] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [progress, setProgress] = useState(0);
  // const handleStickyClose = (): void => {
  //   setCloseSticky(true);
  // };
  const images = [
    <img
      src="/assets/images/f565-partnership-details-img.webp"
      key="first"
      alt="Partnership Details"
      id="loading1"
      className="details-images"
    />,
    <img
      src="/assets/images/f565-income-deduction-img.webp"
      key="second"
      alt="Income & Deductions "
      className="details-images"
    />,
    <img
      src="/assets/images/f1065-partner-information-img.webp"
      key="third"
      alt="Shareholder Information"
      className="details-images"
    />,
    <img
      src="/assets/images/f1065-k1-allocation-img.webp"
      key="fourth"
      alt="K-1 Allocations"
      className="details-images"
    />,
    <img
      src="/assets/images/f565-balance-sheet-img.webp"
      key="fifth"
      alt="Balance Sheet Data "
      className="details-images"
    />,
  ];
  const loader = ['loading1', 'loading2', 'loading3', 'loading4', 'loading5'];
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (currentIndex === images.length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    }, 10000);

    return () => clearInterval(intervalId);
  }, [currentIndex + 1]);
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (currentIndex === loader.length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    }, 10000);

    return () => clearInterval(intervalId);
  }, [currentIndex + 1]);

  // refs
  // const leftScrollRef = useRef(null)s; // the scrollable container
  // const sectionsRef = useRef<any>([]); // array of section elements

  // state for which image to show
  // const [scrollIndex, setScrollIndex] = useState(0);

  // example images (replace these paths with your real images)

  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.isIntersecting) {
  //           const target = entry.target as HTMLElement;
  //           const index = Number(target.dataset.index);
  //           setScrollIndex(index);
  //         }
  //       });
  //     },
  //     {
  //       threshold: 0.6, // observe viewport, not left container
  //     }
  //   );

  //   sectionsRef.current.forEach((sec: HTMLElement) => {
  //     if (sec) observer.observe(sec);
  //   });

  //   return () => observer.disconnect();
  // }, []);
  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 3, 16));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 3, 16)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);

  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Days</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="California Form 565 | File CA Partnership Tax Return"
          description="File California Form 565 (Partnership Return of Income) online with TaxZerone. FTB-compliant, accurate, and deadline-ready for all California partnerships."
          keywords=""
          canonical="business-tax/efile-california-form-565/"
          jsonLdPricing=""
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount=""
          ogShareImg=""
        />
      }
    >
      {/* <Hidden smDown>
        {!closeSticky && (
          <Box
            sx={{
              position: 'fixed',
              bottom: 0,
              width: '100%',
              left: 0,
              right: 0,
              zIndex: 3,
            }}
          >
            <Container
              maxWidth="md"
              sx={{
                backgroundColor: '#fff',
                mx: { xs: 3, lg: 'auto' },
                width: 'auto',
                py: 1.5,
                borderTopLeftRadius: 6,
                borderTopRightRadius: 6,
                boxShadow: '0 0 20px rgba(0,0,0,.5)',
                position: 'relative',
                borderWidth: 2,
                borderColor: '#414042',
                borderStyle: 'solid',
                borderBottom: 'none',
              }}
            >
              <Tooltip title="Close" arrow placement="top">
                <IconButton
                  aria-label="close"
                  size="small"
                  onClick={handleStickyClose}
                  sx={{
                    position: 'absolute',
                    right: -12,
                    top: -12,
                    color: '#fff',
                    backgroundColor: '#e11d1d',
                    '&:hover, &:focus': {
                      backgroundColor: '#b01919',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={{ xs: 1, sm: 1, md: 2 }}
                sx={{ justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Box>
                  <Typography
                    component="div"
                    variant="body1"
                    sx={{
                      textAlign: { xs: 'center', sm: 'left' },
                      fontSize: { xs: 15, sm: 17, md: 18, lg: '1.25rem' },
                      //  color: '#ccc',
                      lineHeight: 1.3,
                    }}
                  >
                    <strong>Thank you</strong> for trusting{' '}
                    <b style={{ fontWeight: 600, color: '#213e99' }}>
                      TaxZerone
                    </b>{' '}
                    with your <strong> Form 1065</strong> filing.
                  </Typography>
                </Box>  */}
      {/* <Stack direction="row" alignItems="center" spacing={2}>
                  <Countdown date={lastDayTaxSeason} renderer={renderer} />
                  <Hidden mdUp>
                    <Box sx={{ textAlign: 'center' }}>
                      <Button
                        variant="contained"
                        size="medium"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                        sx={{
                          textTransform: 'none',
                          px: 2.5,
                          display: 'inline-block',
                          boxShadow: 'none',
                          borderRadius: 4.2,
                          backgroundColor: '#213e99',
                          whiteSpace: 'nowrap',
                          '&:hover, &:focus': {
                            backgroundColor: '#172b6b',
                          },
                        }}
                      >
                        E-File Now
                      </Button>
                    </Box>
                  </Hidden>
                </Stack>
                <Hidden mdDown>
                  <Box sx={{ textAlign: 'center' }}>
                    <Button
                      variant="contained"
                      size="medium"
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                      sx={{
                        textTransform: 'none',
                        px: 2.5,
                        display: 'inline-block',
                        boxShadow: 'none',
                        borderRadius: 4.2,
                        backgroundColor: '#213e99',
                        whiteSpace: 'nowrap',
                        '&:hover, &:focus': {
                          backgroundColor: '#172b6b',
                        },
                      }}
                    >
                      E-File Now
                    </Button>
                  </Box>
                </Hidden> */}
      {/* </Stack>
            </Container>
          </Box>
        )}
      </Hidden> */}
      <BusinessTaxSubMenu />
      {/* <ExitPopup1065 /> */}
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #1f6666, #106ad2)',
            p: 1.5,
            px: 4,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 16, sm: 17, md: 20, lg: '1.25rem' },
                color: '#d9d9d9',
              }}
            >
              <strong>📢Attention Partnerships! </strong> E-file your{' '}
              <span style={{ fontWeight: 600, color: '#ffbb00' }}>
                {' '}
                2025 Form 1065
              </span>{' '}
              online and securely deliver Schedule K-1s to partners.
            </Typography>
            <Box sx={{}}> */}
      {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  March 16, 2026
                </span>
                ):
              </Typography> */}
      <Countdown date={lastDayTaxSeason} renderer={renderer} />
      {/* </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                sx={{
                  backgroundColor: '#ee4266',
                  '&:hover, &:focus': {
                    backgroundColor: '#8338ec',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#fff',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: 18,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-file Now!
              </Button> */}
      {/* <Typography
                variant="body2"
                sx={{ textAlign: 'center', mt: 1, color: '#fff' }}
              >
                {' '}
                <b style={{ color: '#fff' }}> Save 10%</b> with code{' '}
                <b style={{ color: '#f4d58d' }}> TZOTE10</b>
              </Typography> */}
      {/* </Box>
          </Stack>
        </Box>
      </Container> */}

      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                File{' '}
                <span className="highlight-container">
                  <span className="highlight">California Form 565</span>
                </span>{' '}
                Online
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                California partnerships have a state-level filing obligation
                that's entirely separate from the IRS. TaxZerone makes it simple
                to complete and submit Form 565 to the FTB — accurately, on
                time, and without the guesswork.
              </Typography>
              <Stack spacing={2} direction="row">
                <Box sx={{ width: 300 }}>
                  {' '}
                  <List>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1d1917',
                        }}
                      >
                        <CheckCircleIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>FTB-Compliant Filing</ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1d1917',
                        }}
                      >
                        <CheckCircleIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        Built-in Accuracy Checks
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
                <Box>
                  <List>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1d1917',
                        }}
                      >
                        <CheckCircleIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        Automatic Schedule K-1 (565) Generation
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1d1917',
                        }}
                      >
                        <CheckCircleIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        Trusted by Partnership Owners & CPAs Across California
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Stack>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 1 }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mr: { xs: 0, md: 4 },
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form565`}
                  >
                    Start Filing Form 565
                  </Button>
                  {/* <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Takes 3 steps and less than 5 minutes
                  </Typography> */}
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/ftb-logo.webp" />
                      <source srcSet="/assets/images/ftb-logo.png" />
                      <Box
                        component="img"
                        src="/assets/images/ftb-logo.png"
                        loading="lazy"
                        alt="FTB e-file provider"
                        width={80}
                        height={79}
                        sx={{
                          width: { xs: 70, md: 80 },
                          height: { xs: 69, md: 79 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
              <Box
                sx={{
                  position: 'relative',
                  maxWidth: 580,
                  mx: { xs: 'auto', md: 0 },
                  mt: 5,
                }}
              />
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/f565-landing-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/f565-landing-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/f565-landing-img.png"
                  alt="File California Form 565 Online"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/f565-landing-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/f565-landing-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/f565-landing-img-sm.png"
                  alt="File California Form 565 Online"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                File California Form 565 for Just{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 30, md: 40 },
                  }}
                >
                  $69.99{' '}
                </Box>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 17, md: 17, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 1,
                  textAlign: 'left',
                }}
              >
                One flat fee. No hidden charges. Your complete Form 565 e-filing
                includes Schedule K-1 (565) preparation for all partners and
                direct submission to the California Franchise Tax Board.
              </Typography>
            </Box>
            {/* <Typography variant="body1">Add-on services:</Typography>
              <Box component={'ul'} sx={{ mt: -0.1 }}>
                <li>
                  Postal K-1 Delivery:{' '}
                  <Box
                    component={'strong'}
                    sx={{
                      color: '#ffffffff',
                      fontSize: { xs: 24, sm: 24 },
                    }}
                  >
                    $1.75
                  </Box>{' '}
                  per recipient
                </li>
                <li>
                  {' '}
                  ZeroneVault Digital Delivery: Postal K-1 Delivery:{' '}
                  <Box
                    component={'strong'}
                    sx={{
                      color: '#fffad1ff',
                      fontSize: { xs: 24, sm: 24 },
                    }}
                  >
                    $0.50
                  </Box>{' '}
                  per recipient{' '}
                </li>
              </Box> */}

            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 150 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form565`}
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                Get Started
              </Button>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                    mb: 0.8,
                  }}
                >
                  What Is California Form 565?
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  California Form 565—officially{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Partnership Return of Income—
                  </span>
                  is the annual state tax return filed by partnerships with the
                  California Franchise Tax Board (FTB). It reports the
                  partnership’s California-source income, deductions, credits,
                  and other required tax information for the year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Partnerships doing business in California or receiving
                  California-source income generally must file Form 565
                  annually, even if they operated at a loss or had limited
                  activity. The return also serves as the basis for issuing
                  Schedule K-1 (565) to each partner to report their share of
                  California partnership income.
                </Typography>

                <Alert
                  severity="warning"
                  icon={false}
                  sx={{
                    mb: 0,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b> Important: </b> Filing federal IRS Form 1065 does not
                  satisfy your California filing requirement. California Form
                  565 must be filed separately with the FTB.
                </Alert>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/california-form-565-img.webp" />
                  <source srcSet="/assets/images/california-form-565-img.png" />
                  <img
                    src="/assets/images/california-form-565-img.png"
                    alt="What Is California Form 565?"
                    className="img-responsive"
                    loading="lazy"
                    width={500}
                    height={500}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',

          pb: 6,
          pt: 1,
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Grid container spacing={2}>
            <Grid
              size={{ md: 12, xs: 12 }}
              sx={{ mt: 4, justifyContent: 'center' }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mt: 3,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                California vs. Federal — What's Different?
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
                Many partnership owners assume their federal 1065 filing covers
                everything.{' '}
                <Hidden smDown>
                  <br />{' '}
                </Hidden>{' '}
                It doesn't. Here's what makes Form 565 unique:
              </Typography>
              <Box component="div" sx={{ mb: 4, maxWidth: 900, m: 'auto' }}>
                <TableContainer sx={{ borderRadius: 2 }}>
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            color: '#ffffff',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            backgroundColor: '#fff',
                            textAlign: 'center',
                            borderBottom: 'none',
                          }}
                        />

                        <TableCell
                          sx={{
                            color: '#ffffff',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#5b0679',
                            fontSize: 17,
                          }}
                        >
                          Federal Form 1065
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#ffffff',
                            fontWeight: 600,
                            width: 300,
                            textAlign: 'center',
                            borderBottom: '1px solid #828282',
                            backgroundColor: '#5b0679',
                            fontSize: 17,
                          }}
                        >
                          California Form 565
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            backgroundColor: '#fff',
                            textAlign: 'center',
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: 16,
                          }}
                        >
                          Filed with
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 15,
                          }}
                        >
                          IRS
                        </TableCell>

                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 15,
                          }}
                        >
                          California FTB
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: 16,
                          }}
                        >
                          Annual tax
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            borderBottom: '1px solid #828282',
                            fontSize: 15,
                          }}
                        >
                          None
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            borderBottom: '1px solid #828282',
                            fontSize: 15,
                          }}
                        >
                          $800/year (LPs, LLPs, REMICs)
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            backgroundColor: '#fff',
                            textAlign: 'center',
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: 16,
                          }}
                        >
                          Due date (calendar year)
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 15,
                          }}
                        >
                          March 16, 2026
                        </TableCell>

                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 15,
                          }}
                        >
                          March 16, 2026
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: 16,
                          }}
                        >
                          QBI deduction (§199A)
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            borderBottom: '1px solid #828282',
                            fontSize: 15,
                          }}
                        >
                          Allowed
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            borderBottom: '1px solid #828282',
                            fontSize: 15,
                          }}
                        >
                          Not applicable in California
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            backgroundColor: '#fff',
                            textAlign: 'center',
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: 16,
                          }}
                        >
                          Opportunity zone deferral
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 15,
                          }}
                        >
                          Allowed
                        </TableCell>

                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',

                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 15,
                          }}
                        >
                          California does not conform
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'center',
                            backgroundColor: '#fff',
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: 16,
                          }}
                        >
                          Apportionment
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 15,
                          }}
                        >
                          N/A
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            borderBottom: '1px solid #828282',
                            fontSize: 15,
                          }}
                        >
                          Schedule R required for multi-state income
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            backgroundColor: '#fff',
                            textAlign: 'center',
                            fontWeight: 500,
                            fontSize: 16,
                          }}
                        >
                          Partner K-1 form
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 15,
                          }}
                        >
                          Schedule K-1 (1065)
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 15,
                          }}
                        >
                          Schedule K-1 (565)
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <Typography variant="body1" sx={{ mt: 2, textAlign: 'center' }}>
                California does not always conform to federal tax law.
                Deductions allowed on your Form 1065{' '}
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>{' '}
                may not be recognized on Form 565 — which is why a dedicated
                California filing matters.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          pb: 6,
          pt: 1,
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6, sm: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                // sx={{
                //   display: 'flex',
                //   justifyContent: 'center',
                //   alignItems: 'center',
                //   height: '100%',
                //   textAlign: { xs: 'center', md: 'right' },
                //   my: { xs: 3, md: 0 },
                // }}
                className="image-container"
              >
                <Box
                  component={motion.div}
                  key={currentIndex}
                  className="image-fade"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1.5, ease: 'easeInOut' }}
                  sx={{
                    '& img': {
                      width: '100% !important',
                      height: { xs: 'auto', md: 480 },
                    },
                  }}
                >
                  {images[currentIndex]}
                </Box>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 2,
                  }}
                >
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#ac6ec6bc',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 0 ? 'loading-effect' : ''}
                    id="loading1"
                  />{' '}
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#ac6ec6bc',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 1 ? 'loading-effect' : ''}
                    id="loading2"
                  />
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#ac6ec6bc',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 2 ? 'loading-effect' : ''}
                    id="loading3"
                  />
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#ac6ec6bc',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 3 ? 'loading-effect' : ''}
                    id="loading4"
                  />
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#ac6ec6bc',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 4 ? 'loading-effect' : ''}
                    id="loading5"
                  />
                </Stack>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 12 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box sx={{ ml: { md: 3, xs: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,
                    mb: 1,
                    textAlign: 'left',
                  }}
                >
                  What You'll Need to File <br /> Form 565
                </Typography>
                <Typography variant="body1" sx={{ mb: 0, ml: 3.5 }}>
                  Gather these details before you start:
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 5 },
                    mt: { xs: 0, md: 2 },
                    mb: { xs: 0, md: 3 },
                    '& li': { display: 'flex', mb: 2 },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Partnership Details:
                      </span>{' '}
                      Name, FEIN, California Secretary of State file number, and
                      type of partnership (GP, LP, LLP, or REMIC)
                    </Box>
                  </li>
                  <li>
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Income & Deductions:
                      </span>{' '}
                      California-sourced revenue, cost of goods sold, operating
                      expenses, and applicable deductions
                    </Box>
                  </li>
                  <li>
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Partner Information:
                      </span>{' '}
                      Name, TIN, ownership percentage, and distributions for
                      each partner
                    </Box>
                  </li>
                  <li>
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        K-1 Allocations:{' '}
                      </span>{' '}
                      Each partner's pro-rata share of California income,
                      losses, deductions, and credits
                    </Box>
                  </li>
                  <li>
                    {' '}
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Balance Sheet Data:{' '}
                      </span>
                      Assets, liabilities, and capital accounts at the beginning
                      and end of the tax year
                    </Box>
                  </li>{' '}
                  <li>
                    {' '}
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Apportionment Details:{' '}
                      </span>
                      If the partnership operates in multiple states, Schedule R
                      data will be needed
                    </Box>
                  </li>{' '}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 5.5, sm: 12, lg: 5 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Eligibility Checklist — Does Your Partnership Need to File
                  Form 565?
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Your partnership must file Form 565 if any of the following
                  apply:
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 0 },
                    mb: { xs: 0, md: 0 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box> Your partnership is organized in California</Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Your partnership is registered with the California
                      Secretary of State
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Your partnership is actively doing business in California
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Your partnership derives income from California sources
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Your partnership is a Limited Partnership (LP), Limited
                      Liability Partnership (LLP), or REMIC classified as a
                      partnership
                    </Box>
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  💡{' '}
                  <span style={{ fontWeight: 600 }}>
                    "Doing business" in California
                  </span>{' '}
                  includes partnerships whose California sales exceed $757,070
                  (or 25% of total sales), whose California property exceeds
                  $75,707 (or 25% of total property), or whose California
                  payroll exceeds $75,707 (or 25% of total payroll) — even
                  without a physical office in the state.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Even if your partnership was inactive during the year, LPs,
                  LLPs, and REMICs registered in California are still required
                  to file and pay the $800 annual tax.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6.5, sm: 12, lg: 7 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f565-eligibility-checklist-img.webp" />
                  <source srcSet="/assets/images/f565-eligibility-checklist-img.png" />
                  <img
                    src="/assets/images/f565-eligibility-checklist-img.png"
                    alt="Eligibility Checklist — Does Your Partnership Need to File Form 565?"
                    className="img-responsive"
                    loading="lazy"
                    width={550}
                    height={400}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid size={{ xs: 12, md: 6, sm: 12, lg: 6 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'left' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f565-annual-tax-img.webp" />
                  <source srcSet="/assets/images/f565-annual-tax-img.png" />
                  <img
                    src="/assets/images/f565-annual-tax-img.png"
                    alt="The $800 Annual Tax — Don't Miss It"
                    className="img-responsive"
                    loading="lazy"
                    width={500}
                    height={500}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 12, lg: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  The $800 Annual Tax — Don't Miss It
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Unlike the IRS, California imposes an{' '}
                  <span style={{ fontWeight: 600 }}>$800 annual tax</span> on
                  all LPs, LLPs, and REMICs subject to the franchise tax. This
                  applies even if your partnership:
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 0 },
                    mb: { xs: 0, md: 0 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box> Had zero revenue </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>Operated at a net loss</Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>Was inactive for the entire year</Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Filed a short-period return of less than 12 months
                    </Box>
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  This $800 must be paid by the original due date —{' '}
                  <span style={{ fontWeight: 600 }}>March 16, 2026</span> for
                  calendar-year filers — even if you've filed an extension.
                  Missing this payment triggers late payment penalties and
                  interest on top of the amount owed.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Cancellation Exception:
                  </span>{' '}
                  If your LP or LLP timely files a final return, stops doing
                  business in California after the final taxable year, and files
                  dissolution documents with the California SOS within 12 months
                  of that final return, the $800 annual tax will{' '}
                  <span style={{ fontWeight: 600 }}> not</span> be assessed for
                  subsequent years.
                </Typography>
                <Typography variant="body1">
                  <span style={{ fontWeight: 600 }}> Example:</span> An LP files
                  a timely 2025 final return on March 16, 2026, pays the $800
                  for 2025, does no business after 2025, and files its
                  cancellation paperwork with the SOS before March 15, 2027. The
                  LP owes no $800 tax for 2026.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'row', md: 'row' } }}
          >
            <Grid
              size={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 0 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Form 565 Filing Deadlines — 2025 Tax Year
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  These deadlines apply to partnerships using a calendar year
                  <span style={{ fontWeight: 600 }}>
                    (January 1 – December 31, 2025):
                  </span>
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 200, fontWeight: 600 }}
                          >
                            Filing Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Deadline
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{ backgroundColor: '#fff' }}>
                          <TableCell>Original return </TableCell>
                          <TableCell>
                            <span style={{ fontWeight: 600, fontSize: 16 }}>
                              {' '}
                              March 16, 2026
                            </span>{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Partner K-1 (565) distribution</TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: 16 }}>
                            March 16, 2026{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#fff' }}>
                          <TableCell>With automatic extension </TableCell>
                          <TableCell>
                            <span style={{ fontWeight: 600, fontSize: 16 }}>
                              {' '}
                              October 15, 2026
                            </span>{' '}
                            (7-month extension){' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 12, sm: 12, lg: 12 }}
              sx={{ mx: { xs: 0, sm: 2, md: 24 } }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 3,
                  minHeight: '100%',
                  backgroundColor: '#f2e9e4',
                }}
                className="pattern-bg"
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 22, sm: 20, xs: 18 },
                    mb: 1,
                    fontWeight: 600,
                  }}
                >
                  For Fiscal-Year Partnerships:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  The original due date is the{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    15th day of the 3rd month
                  </span>{' '}
                  after your fiscal year closes. The extended deadline is{' '}
                  <span style={{ fontWeight: 600 }}>
                    7 months after the original due date
                  </span>
                  .{' '}
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  Examples:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Fiscal year ends June 30, 2025 → Original due date: September
                  15, 2025 → Extended due date: April 15, 2026.
                </Typography>
              </Paper>
            </Grid>
            <Alert
              severity="warning"
              // icon={false}
              sx={{
                mb: 0,
                borderLeft: '3px solid rgb(102, 60, 0)',
                fontStyle: 'italic',
                mx: 'auto',
                maxWidth: 900,
              }}
            >
              California's extension is a{' '}
              <span style={{ fontWeight: 600 }}> filing extension only</span> —
              it does not extend your payment deadline. The $800 annual tax (for
              LPs, LLPs, and REMICs) must be paid by March 16, 2026 to avoid
              penalties and interest.
            </Alert>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to File Form 565 with TaxZerone
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing your Form 1065 is quick and streamlined—just follow these
                steps:
              </Typography> */}
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/f565-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/f565-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/f565-steps-img.png"
                  alt="How to File Form 565 with TaxZerone "
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Step 1 — Create Your TaxZerone Account"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Step 1 — Create Your TaxZerone Account
                    </Typography>
                    <Typography variant="body1">
                      Sign up and select California Form 565 from the business
                      tax forms section.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Step 2 — Enter Partnership & Partner Details"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Step 2 — Enter Partnership & Partner Details
                    </Typography>
                    <Typography variant="body1">
                      Input your California Secretary of State file number,
                      FEIN, tax year, partnership type, and partner information
                      through our guided interface.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Step 3 — Report Income, Deductions & Credits"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Step 3 — Report Income, Deductions & Credits
                    </Typography>
                    <Typography variant="body1">
                      Enter your California-sourced income, allowable
                      deductions, and applicable credits. TaxZerone
                      automatically generates Schedule K-1 (565) for each
                      partner.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-4-icon.webp" />
                        <source srcSet="/assets/images/step-4-icon.png" />
                        <img
                          src="/assets/images/step-4-icon.png"
                          alt="Step 4 — Validate Before You File"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Step 4 — Validate Before You File
                    </Typography>
                    <Typography variant="body1">
                      Our built-in error checks scan for missing TINs,
                      calculation mismatches, and common FTB rejection triggers
                      — giving you a clean return before submission.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-5-icon.webp" />
                        <source srcSet="/assets/images/step-5-icon.png" />
                        <img
                          src="/assets/images/step-5-icon.png"
                          alt="Step 5 — Submit to the FTB & Distribute K-1s"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Step 5 — Submit to the FTB & Distribute K-1s
                    </Typography>
                    <Typography variant="body1">
                      File directly with the California FTB through TaxZerone.
                      After filing, securely distribute Schedule K-1 (Form 565)
                      copies to partners digitally through ZeroneVault (secure
                      portal) or by mail.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    mb: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form565`}
                >
                  File Form 565 Now
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone for Form 565?
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="FTB-Compliant Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  FTB-Compliant Filing
                </Typography>
                <Typography variant="body1">
                  File directly with the California Franchise Tax Board on a
                  platform built for state-level accuracy and compliance.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided Step-by-Step Workflow"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided Step-by-Step Workflow
                </Typography>
                <Typography variant="body1">
                  Whether you're filing Form 565 for the first time or the
                  tenth, our system walks you through every section — no tax
                  expertise required.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/auto-genert-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/auto-genert-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/auto-genert-icon.png"
                      alt="Auto-Generated Schedule K-1 (565)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Auto-Generated Schedule K-1 (565)
                </Typography>
                <Typography variant="body1">
                  Partner K-1s are created automatically from your return data
                  and ready for immediate digital or postal delivery.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/auto-genert-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/auto-genert-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/auto-genert-icon.png"
                      alt="Transparent Flat-Fee Pricing "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Automatic Federal Data Import
                </Typography>
                <Typography variant="body1">
                  If you filed your federal Form 1065 with TaxZerone, your
                  information is automatically imported into your California
                  Form 565, reducing manual data entry and helping you file
                  faster.
                </Typography>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/error-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/error-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/error-icon.png"
                      alt="Advanced Error Checks "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Advanced Error Checks
                </Typography>
                <Typography variant="body1">
                  We scan for missing information, calculation errors, and
                  California-specific compliance issues before your return
                  reaches the FTB.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Dedicated Support Team"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Dedicated Support Team
                </Typography>
                <Typography variant="body1">
                  Have a California-specific question? Our support team is
                  available via chat, email, and phone to help you file with
                  confidence.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6, sm: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/1120s-tax-professional-img.webp" />
                  <source srcSet="/assets/images/1120s-tax-professional-img.png" />
                  <img
                    src="/assets/images/1120s-tax-professional-img.png"
                    alt="Special Pricing for CPAs & Tax Professionals"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 12 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  Special Pricing for CPAs & Tax Professionals
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                  Filing Form 565 for multiple California partnerships?
                  TaxZerone offers exclusive bulk pricing, reusable client
                  profiles, and dedicated support for tax professionals managing
                  high-volume filings.
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Bigger filings = Bigger discounts </li>
                  <li>
                    Save time with reusable business profiles across clients
                  </li>
                  <li>White-glove support during peak filing season</li>
                </Box>
                <Typography variant="body1" sx={{ mt: 2 }}>
                  📞{' '}
                  <Link
                    // href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                    href="/contact-us/"
                    sx={{ color: '#0202ff' }}
                  >
                    Contact Us Now
                  </Link>{' '}
                  to unlock your custom CPA pricing and make this California
                  filing season your smoothest yet.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      {/* <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          File California Form 100S Before the Deadline
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Prepare your return, generate shareholder K-1s, and meet California
          filing requirements with TaxZerone.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form100s`}
          >
            File Form 100S Now
          </Button>
        </Box>
      </Box> */}
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
        aria-labelledby="f565-faq"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={2}
            direction="row"
            justifyContent="center"
            className="MuiGrid-root-width"
            sx={{ my: { xs: 0, sm: 2 } }}
          >
            <Grid
              size={{ xs: 12, md: 9, sm: 10 }}
              textAlign="left"
              my={{ xs: 2, sm: 5 }}
              mb={3}
            >
              <Typography
                id="f565-faq"
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 5,
                  textAlign: 'center',
                }}
              >
                Frequently Asked Questions
              </Typography>
              <Box
                component="div"
                sx={{ mb: 5 }}
                itemScope
                itemType="https://schema.org/FAQPage"
              >
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Is California Form 565 the same as federal Form 1065?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Typography component="p" sx={{ mt: 1 }}>
                        No. Form 1065 is filed with the IRS to meet federal
                        obligations. Form 565 is a separate return filed with
                        the California Franchise Tax Board. Both are required
                        for California partnerships, and the taxable income
                        figures can differ because California does not conform
                        to all federal tax rules.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Do I have to file Form 565 if my partnership had no income?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box component="div" itemProp="text">
                      <Typography component="p" sx={{ mt: 1 }}>
                        It depends on your entity type. LPs and LLPs registered
                        in California must file Form 565 and pay the $800 annual
                        tax even if the partnership had no income or was
                        inactive. General partnerships that are not doing
                        business in California and have no California-source
                        income are generally not required to file.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    What is the filing deadline for California Form 565?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box component="div" itemProp="text">
                      <Typography component="p" sx={{ mt: 1 }}>
                        For calendar-year partnerships, the 2025 return is due
                        <span style={{ fontWeight: 600 }}> March 16, 2026</span>
                        . With California's automatic 7-month extension, the
                        extended filing deadline is{' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          October 15, 2026
                        </span>
                        . Fiscal year filers use the 15th day of the 3rd month
                        after their tax year ends as their original due date.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35) !important',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Does a filing extension also extend my payment deadline?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                      No. California's automatic extension is a filing extension
                      only. The $800 annual tax (for LPs, LLPs, and REMICs) must
                      still be paid by{' '}
                      <span style={{ fontWeight: 600 }}> March 15, 2026</span>{' '}
                      to avoid late payment penalties and interest.
                    </Typography>
                  </Box>
                </Box>
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35) !important',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    What is the penalty for filing Form 565 late?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                      The FTB charges{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        $18 per partner, per month{' '}
                      </span>{' '}
                      (or partial month) for each month the return is late — up
                      to a maximum of 12 months. A partnership with 10 partners
                      filing 3 months late, for example, would face a $540
                      penalty — before interest.
                    </Typography>
                  </Box>
                </Box>
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35) !important',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Does my LLC need to file Form 565?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                      Generally no. LLCs classified as partnerships file{' '}
                      <span style={{ fontWeight: 600 }}> Form 568</span>, not
                      Form 565. The narrow exception is for nonregistered
                      foreign LLCs and LPs that derive California income but are
                      not organized in California and are not registered with
                      the California SOS.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </AppLayout>
  );
};

export default Form565;
